import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/login", { email: email.trim().toLowerCase(), password: password.trim() });
      toast.success("Welcome back");
      // Return to the originally requested admin record if provided (deep-link from a notification).
      const next = new URLSearchParams(location.search).get("next");
      const safeNext = next && next.startsWith("/admin") ? next : "/admin";
      nav(safeNext);
    } catch (err) {
      toast.error(err?.response?.status === 401 ? "Invalid email or password" : "Couldn't sign in — please try again");
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#0B0B0C] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white/5 border border-[color:var(--border-subtle)]"><Lock className="h-6 w-6 text-gold-soft" /></div>
          <h1 className="font-display text-2xl font-semibold text-white">Ascendia Admin</h1>
          <p className="text-sm text-muted-c mt-1">Sign in to manage your site</p>
        </div>
        <form onSubmit={submit} className="ascendia-card p-6 space-y-4">
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} autoComplete="username" data-testid="admin-email-input" placeholder="Email" className="w-full rounded-xl bg-black/40 border border-[color:var(--border-subtle)] px-4 py-3 text-sm text-white placeholder:text-white/35 focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)]" />
          <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" autoComplete="current-password" data-testid="admin-password-input" placeholder="Password" className="w-full rounded-xl bg-black/40 border border-[color:var(--border-subtle)] px-4 py-3 text-sm text-white placeholder:text-white/35 focus:outline-none focus:ring-2 focus:ring-[color:var(--ring)]" />
          <button type="submit" disabled={busy} data-testid="admin-login-button" className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-gold px-6 py-3 text-sm font-semibold text-black hover:bg-gold-soft transition-colors disabled:opacity-50">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign In"}</button>
        </form>
        <a href="/" className="mt-6 block text-center text-sm text-muted-c hover:text-white">← Back to site</a>
      </div>
    </div>
  );
}
